import { AvatarUpload, TextInput } from "components/core";
import { DistrictPicker } from "containers";
import { FormikProps } from "formik";
import _ from "lodash";
import { FC } from "react";
import { ICewpUserFormSchema } from "./schema";

export interface CewpUserFormProps {
  form: FormikProps<ICewpUserFormSchema>;
}

export const CewpUserForm: FC<CewpUserFormProps> = ({ form }) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div>
        <span className="text-xs font-light">User Information</span>
        <div className="grid grid-cols-2 gap-6 mt-2">
          <div>
            <AvatarUpload id="profileImageUrl" label="Photo" {...form} />
          </div>
          <div>
            <TextInput
              id="lastName"
              label="Last Name"
              type="text"
              placeholder="e.g. Mensah"
              required
              {...form}
            />
          </div>
          <div>
            <TextInput
              id="firstName"
              label="Other Names"
              type="text"
              placeholder="e.g. Enoch Nana Nyankah"
              required
              {...form}
            />
          </div>
          <div>
            <TextInput
              id="phoneNumber"
              label="Phone Number"
              type="text"
              placeholder="e.g. 0550123292"
              required
              {...form}
            />
          </div>
          <div>
            <TextInput
              id="emailAddress"
              label="Email Address"
              type="email"
              placeholder="e.g. nyankahmensah@gmail.com"
              required
              {...form}
            />
          </div>
          <div>
            <TextInput
              id="certificationNumber"
              label="Certification Number"
              type="text"
              placeholder="Certification number"
              required
              {...form}
            />
          </div>
        </div>
      </div>
      <div className="pt-6">
        <span className="text-xs font-light">Districts</span>
        <div className="grid grid-cols-2 gap-6 mt-2">
          {_.times(form.values.districts?.length + 1, (idx) => (
            <div key={idx}>
              <DistrictPicker
                id={`districts.[${idx}]`}
                label={`District ${idx + 1}`}
                placeholder="Select district"
                required={idx !== form.values.districts.length}
                {...form}
                rawId
                position="top"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CewpUserForm;
